var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallsIcon = function SvgCallsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calls"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.86807 6.41638C3.04567 7.73878 3.74087 10.778 6.48167 13.5188C9.22247 16.2596 12.2609 16.9548 13.5841 17.1324C14.5425 17.3396 15.5817 17.0764 16.3265 16.3316C17.4913 15.1668 13.2721 10.9476 12.1073 12.1124L11.3641 12.8556L7.14487 8.63638L7.88727 7.89318C9.05207 6.72838 4.83287 2.50918 3.66807 3.67398C2.92327 4.41878 2.66007 5.45798 2.86807 6.41638Z",
    fill: "#8F979A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.67139 3.67208L7.88979 7.89048C9.05219 6.72488 9.05219 4.83848 7.88739 3.67368C6.72419 2.51048 4.83699 2.50968 3.67139 3.67208Z",
    fill: "#8F979A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1089 12.1096L16.3273 16.328C17.4897 15.1632 17.4897 13.276 16.3249 12.1112C15.1609 10.948 13.2745 10.9472 12.1089 12.1096Z",
    fill: "#8F979A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.4152 8.49657C17.1824 8.72937 16.82 8.80297 16.5056 8.65337C16.1064 8.46297 15.9368 7.98697 16.1264 7.58697C16.636 6.51657 16.42 5.23897 15.5904 4.40937C14.7608 3.57977 13.4832 3.36457 12.4128 3.87337C12.0136 4.06297 11.5368 3.89337 11.3464 3.49417C11.156 3.09497 11.3272 2.61737 11.7256 2.42777C13.4064 1.62857 15.4144 1.97017 16.7216 3.27737C18.0288 4.58457 18.3704 6.59257 17.5712 8.27337C17.532 8.35897 17.4784 8.43337 17.4152 8.49657Z",
    fill: "#8F979A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.2006 8.39531C14.0842 8.39531 14.8006 7.67897 14.8006 6.79531C14.8006 5.91166 14.0842 5.19531 13.2006 5.19531C12.3169 5.19531 11.6006 5.91166 11.6006 6.79531C11.6006 7.67897 12.3169 8.39531 13.2006 8.39531Z",
    fill: "#8F979A"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calls-icon.3ddef6d8d6332d817f439a8737a93eba.svg";